export const EnvVariables: Variable[] = [
  {
    name: 'AAX',
    example_darwin: '/Library/Application Support/Avid/Audio/Plug-Ins',
    example_win32: 'C:\\Program Files\\Common Files\\Avid\\Audio\\Plug-Ins',
  },
  { name: 'ALLUSERSPROFILE', example_win32: 'C:\\ProgramData' },
  { name: 'APPDATA', example_win32: 'C:\\Users\\user\\AppData\\Roaming' },
  {
    name: 'AU',
    example_darwin: '~/Library/Audio/Plug-Ins/Components',
  },
  {
    name: 'Documents',
    example_darwin: '/Users/user/Documents',
    example_linux: '/home/user/Documents',
    example_win32: 'C:\\Users\\user\\Documents',
  },
  {
    name: 'HOME',
    example_darwin: '/Users/user',
    example_linux: '/home/user',
    example_win32: 'C:\\Users\\user',
  },
  { name: 'HOMEDRIVE', example_win32: 'C:' },
  { name: 'LOCALAPPDATA', example_win32: 'C:\\Users\\user\\AppData\\Local' },
  { name: 'ProgramData', example_win32: 'C:\\ProgramData' },
  { name: 'ProgramFiles', example_win32: 'C:\\Program Files' },
  { name: 'ProgramFiles(x86)', example_win32: 'C:\\Program Files (x86)' },
  { name: 'PUBLIC', example_win32: 'C:\\Users\\Public' },
  { name: 'SystemDrive', example_win32: 'C:' },
  { name: 'SystemRoot', example_win32: 'C:\\Windows' },
  {
    name: 'TEMP',
    example_darwin: '/var/folders/hs/v02s288n2bxfvmlfb7s6m3q80000gn/T',
    example_linux: '/tmp',
    example_win32: 'C:\\Users\\user\\AppData\\Local\\Temp',
  },
  {
    name: 'USER',
    example_darwin: 'user',
    example_linux: 'user',
    example_win32: 'user',
  },
  {
    name: 'VST',
    example_darwin: '/Library/Audio/Plug-Ins/VST',
    example_win32: 'C:\\Program Files\\Common Files\\VST',
    example_linux: '~./vst',
  },
  {
    name: 'VSTX86',
    example_darwin: '/Library/Audio/Plug-Ins/VST',
    example_win32: 'C:\\Program Files (x86)\\Common Files\\VST',
    example_linux: '~./vst',
  },
  {
    name: 'VST3',
    example_darwin: '/Library/Audio/Plug-Ins/VST3',
    example_win32: 'C:\\Program Files\\Common Files\\VST3',
    example_linux: '~./vst3',
  },
  {
    name: 'VST3X86',
    example_darwin: '/Library/Audio/Plug-Ins/VST3',
    example_win32: 'C:\\Program Files (x86)\\Common Files\\VST3',
    example_linux: '~./vst3',
  },
];

export function isKnownVariable(varName: string): boolean {
  return EnvVariables.some((variable) => variable.name === varName);
}

export type VariableName = (typeof EnvVariables)[number]['name'];

export interface Variable {
  example_darwin?: string;
  example_linux?: string;
  example_win32?: string;
  name: string;
}
